'use client'

import { parseApiAsset } from '@morpho-org/dapp-core'

import { NO_LEND_POINTS } from '@/components/charts/helpers/getPoints'
import { useMarketPoints } from '@/components/charts/hooks/useMarketPoints'
import RewardsHoverCard from '@/components/common/RewardsHoverCard/RewardsHoverCard'

import { useApyCardMarketRateMode } from '../ApyCardMarketRateMode.context'
import { type MarketApyCardData, selectMarketApyRates } from '../MarketApyCard.mapper'

export interface RateCardMarketProps {
  market: MarketApyCardData
}

const RateCardMarket = ({ market }: RateCardMarketProps) => {
  const { rateMode } = useApyCardMarketRateMode()
  const isBorrowMode = rateMode === 'borrow'

  const { apy, instantApy, netApy, dailyApy, weeklyApy, rewards, collateralRewards } =
    selectMarketApyRates(market, rateMode)

  const asset = parseApiAsset(isBorrowMode ? market.collateralAsset : market.loanAsset)

  const borrowPoints = useMarketPoints({
    chainId: market.chainId,
    marketId: market.marketId,
    collateralAddress: market.collateralAsset?.address
  })
  const points = isBorrowMode ? borrowPoints : NO_LEND_POINTS

  return (
    <div
      data-testid="market-apy-rate-card"
      className="bg-muted border-border py-md px-md max-h-[332px] w-[275px] overflow-y-auto rounded-[20px] border-[0.5px] max-lg:max-h-[345px] max-lg:w-full max-lg:rounded-none max-lg:border-none max-lg:bg-transparent max-lg:p-0"
    >
      <RewardsHoverCard
        rewards={rewards}
        apy={apy}
        netApy={netApy}
        variant={isBorrowMode ? 'market' : 'supply'}
        points={points}
        asset={asset}
        collateralRewards={collateralRewards}
        hideNetApyHeader
        instantApy={instantApy}
        dailyApy={dailyApy}
        weeklyApy={weeklyApy}
      />
    </div>
  )
}

export default RateCardMarket
